import { CopilotAgentEvent, CopilotAgentEventKind, CopilotHubMessageType } from 'services/SignalR/CopilotHub';

export interface CopilotStreamState {
  chatText: string;
  documentText: string;
  status?: string;
  events: CopilotAgentEvent[];
  receivedSequence: number;
  runId?: string;
  isDone: boolean;
}

export type CopilotStreamAction =
  | { type: 'reset' }
  | { type: 'status'; status: string | undefined }
  | { type: 'event'; event: CopilotAgentEvent };

export const createInitialStreamState = (): CopilotStreamState => ({
  chatText: '',
  documentText: '',
  events: [],
  receivedSequence: 0,
  isDone: false,
});

export const copilotStreamReducer = (state: CopilotStreamState, action: CopilotStreamAction): CopilotStreamState => {
  switch (action.type) {
    case 'reset':
      return createInitialStreamState();
    case 'status':
      return { ...state, status: action.status };
    case 'event': {
      const receivedSequence = state.receivedSequence + 1;
      const runId = action.event.runId || state.runId;
      const event = { ...action.event, runId, clientSequence: receivedSequence };

      if (event.kind === CopilotAgentEventKind.TextDelta) {
        if (event.messageType === CopilotHubMessageType.Document) {
          return {
            ...state,
            documentText: state.documentText + (event.text ?? ''),
            receivedSequence,
            runId,
          };
        }

        return {
          ...state,
          chatText: state.chatText + (event.text ?? ''),
          receivedSequence,
          runId,
        };
      }

      return {
        ...state,
        status:
          event.kind === CopilotAgentEventKind.Done || event.kind === CopilotAgentEventKind.Error
            ? undefined
            : state.status,
        events: event.kind === CopilotAgentEventKind.Done ? [] : [...state.events, event],
        receivedSequence,
        runId,
        isDone: event.kind === CopilotAgentEventKind.Done || event.kind === CopilotAgentEventKind.Error,
      };
    }
  }
};
